/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationNeedsQuery from '../graphql/queries/GetSimulationNeedsQuery.js';

const useGetSimulationNeedsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationNeedsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationNeeds: R.omit(['__typename'], data?.getSimulationNeeds_simulation_needs || {})
  };
};

export default useGetSimulationNeedsQuery;
